import { render, staticRenderFns } from "./BookingDialogStepShop.vue?vue&type=template&id=68d011b2&"
import script from "./BookingDialogStepShop.vue?vue&type=script&lang=js&"
export * from "./BookingDialogStepShop.vue?vue&type=script&lang=js&"
import style0 from "./BookingDialogStepShop.vue?vue&type=style&index=0&id=68d011b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SmallCardProduct: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/SmallCardProduct.vue').default,CardAddress: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/CardAddress.vue').default})
